import Vue from 'vue'

export default {
  getRedirects ({ commit }) {
    return Vue.axios.get('/redirects')
      .then(({ data }) => commit('ADD_REDIRECTS', data))
  },
  addRedirectSchema ({ commit }, redirect) {
    commit('ADD_REDIRECT_SCHEMA', redirect)
  },
  addRedirect ({ commit }, redirect) {
    return Vue.axios.post('/redirects', { redirect })
      .then(({ data }) => commit('ADD_NEW_REDIRECT', data))
  },
  updateRedirect ({ commit }, redirect) {
    return Vue.axios.put('/redirects', { redirect })
  },
  deleteRedirect ({ commit }, redirectId) {
    return Vue.axios.delete(`/redirects/${redirectId}`)
      .then(() => commit('DELETE_REDIRECT', redirectId))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/redirects.js